import(/* webpackMode: "eager", webpackExports: ["PrismeProvider"] */ "/builds/PortailVente/mCommerce-SSR/b-you/node_modules/@bytel/logger-nextjs/dist/client.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/b-and-you-configurator.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/b-box-configurator/b-box-configurator.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/b-box-configurator/b-box-detail.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/banner-text.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/configurator.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/cta-add-to-cart.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/data-list.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/faq.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/home/home-tabs.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/network-buttons.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/plan-header/b-and-you-price.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/product-detail/product-detail.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/products-catalog/blocked-product-option.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/products-catalog/product-catalog-item.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/(landing)/_components/products-catalog/products-catalog.tsx");
